module.exports = __webpack_public_path__ + "img/ttshop_dfh1.671137cd.svg";